module.exports = __webpack_public_path__ + "img/SAFo_KeyTakeAways_WFH.c8012627.svg";